import {getAsset} from "../../misc/helpers";

export default function DoorPanel({product, reverse}) {
    return (
        <div className="doorPanel">
            <img
                src={product?.gallery?.cover?.url}
                alt=""
                className={`doorPanel__doorImg ${!reverse ? '-reverse' : ''}`}
            />
        </div>
    )
}
